import { useEffect } from 'react';
import { AppDispatch } from "../../redux/store";
import { logout } from "../../redux/actions/authActions";
import { Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import CacheService from '../../services/CacheService';

const Logout = () => {
	const dispatch = AppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		CacheService.clearAll();
		dispatch(logout());
		navigate('/login');
	}, [dispatch, navigate]);

	return (
		<Typography>
			Çıkış yapılıyor...
		</Typography>
	);
}

export default Logout;